import { css } from '@emotion/react';
import { theme } from '../../../design-system/theme/theme';

export const rowStyle = css`
  cursor: pointer;

  &:hover {
    background: ${theme.color.bg};
  }
`;

export const mutedStyle = css`
  color: ${theme.color.textMuted};
`;
